module.exports = __webpack_public_path__ + "static/img/06.6678796.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/06/06.jpg
// module id = OyVB
// module chunks = 0